// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1CTzX","langSelect":"Header_langSelect__2qQN2","lang":"Header_lang__1JzVN","UserMenu":"Header_UserMenu__2ldGO"};